import styled from "styled-components";

export const ActionContainer = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
`;
